import { Store } from "vuex";

const $storage = {
  setObjectItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  getObjectItem(key) {
    const value = localStorage.getItem(key);
    return JSON.parse(value);
  },
  removeItem(key) {
    localStorage.removeItem(key);
  }
};

const historyURL = {
  key: `${window.location.host}__project__URL__historys`,
  clear() {
    $storage.removeItem(this.key);
  },
  add(val) {
    let historys = this.get() || [];
    const path = val.includes("?") ? val.split("?").shift() : val;
    // 移除已存在url
    historys = historys.filter(url => !url.includes(path));
    historys.push(val);
    $storage.setObjectItem(this.key, historys);
  },
  get() {
    return $storage.getObjectItem(this.key) || [];
  }
};

// return parmas object
const resolveURLQuery = url => {
  const params = {};
  if (url.includes("?")) {
    url
      .split("?")
      .pop()
      .split("&")
      .forEach(item => {
        const [key, value] = item.split("=");
        params[key] = value;
      });
  }
  return params;
};

export { historyURL, resolveURLQuery };
